import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { useState } from 'react';
import Axios from 'axios';

export function AddReviewForm() {
    const [enteredName, setName] = useState('');
    const [enteredLocation, setLocation] = useState('');
    const [enteredDate, setDate] = useState('');
    const [enteredP1Coffee, setP1Coffee] = useState('');
    const [enteredP1Location, setP1Location] = useState('');
    const [enteredP1Staff, setP1Staff] = useState('');
    const [enteredP1Food, setP1Food] = useState('');
    const [enteredP1Comments, setP1Comments] = useState('');
    const [enteredP2Coffee, setP2Coffee] = useState('');
    const [enteredP2Location, setP2Location] = useState('');
    const [enteredP2Staff, setP2Staff] = useState('');
    const [enteredP2Food, setP2Food] = useState('');
    const [enteredP2Comments, setP2Comments] = useState('');
    const [enteredPassword, setPassword] = useState('');

    const nameChangeHandler = (event) => {
        setName(event.target.value);
    };
    const locationChangeHandler = (event) => {
        setLocation(event.target.value);
    };
    const dateChangeHandler = (event) => {
        setDate(event.target.value);
    };
    const p1coffeeChangeHandler = (event) => {
        setP1Coffee(event.target.value);
    };
    const p1locationChangeHandler = (event) => {
        setP1Location(event.target.value);
    };
    const p1staffChangeHandler = (event) => {
        setP1Staff(event.target.value);
    };
    const p1foodChangeHandler = (event) => {
        setP1Food(event.target.value);
    };
    const p1commentsChangeHandler = (event) => {
        setP1Comments(event.target.value);
    };
    const p2coffeeChangeHandler = (event) => {
        setP2Coffee(event.target.value);
    };
    const p2locationChangeHandler = (event) => {
        setP2Location(event.target.value);
    };
    const p2staffChangeHandler = (event) => {
        setP2Staff(event.target.value);
    };
    const p2foodChangeHandler = (event) => {
        setP2Food(event.target.value);
    };
    const p2commentsChangeHandler = (event) => {
        setP2Comments(event.target.value);
    };

    const passwordChangeHandler = (event) => {
        setPassword(event.target.value);
    };
    const submitHandler = (event) => {
        event.preventDefault();

        if (enteredPassword === "yumz") {
            //post to nodejs
            Axios.post("/addReviewForm", {data: {
                name: enteredName,
                location: enteredLocation,
                date: enteredDate,
                p1coffee: enteredP1Coffee,
                p1location: enteredP1Location,
                p1staff: enteredP1Staff,
                p1food: enteredP1Food,
                p1comments: enteredP1Comments,
                p2coffee: enteredP2Coffee,
                p2location: enteredP2Location,
                p2staff: enteredP2Staff,
                p2food: enteredP2Food,
                p2comments: enteredP2Comments

            }})
            alert(`Review successfully posted!`);
            // reset();
            //reset the values of input fields
                setName('');
                setLocation('');
                setDate('');
                setP1Coffee('');
                setP1Location('');
                setP1Staff('');
                setP1Food('');
                setP1Comments('');
                setP2Coffee('');
                setP2Location('');
                setP2Staff('');
                setP2Food('');
                setP2Comments('');
        }
        else {
            alert(`Review failed to post. Incorrect password!`);

        }

    };

  return (
    <Form onSubmit={submitHandler} className="AddReview-Form">
        <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name</Form.Label>
            <Form.Control required type="string" placeholder="Enter name of cafe" value={enteredName} onChange={nameChangeHandler} />
        </Form.Group>

        <Form.Group className="mb-3" controlId="location">
            <Form.Label>Location</Form.Label>
            <Form.Control required type="string" placeholder="Enter location of cafe" value={enteredLocation} onChange={locationChangeHandler}/>
        </Form.Group>

        <Form.Group className="mb-3" controlId="date">
            <Form.Label>Date</Form.Label>
            <Form.Control required type="string" placeholder="Enter date visited (YYYY/MM/DD)" value={enteredDate} onChange={dateChangeHandler}/>
        </Form.Group>

        <Form.Text className="AddReview-Form-Text">
          Shin, enter your ratings below:
        </Form.Text> 

        <Row className="AddReview-Form-Shin">
            <Form.Group as={Col} controlId="p1coffeerating">
                <Form.Label>Coffee</Form.Label>
                <Form.Control required type="number" max="10" placeholder="" value={enteredP1Coffee} onChange={p1coffeeChangeHandler}/>
            </Form.Group>

            <Form.Group as={Col} controlId="p1foodrating">
                <Form.Label>Food</Form.Label>
                <Form.Control type="string" placeholder="N/A" value={enteredP1Food} onChange={p1foodChangeHandler}/>
            </Form.Group>

            <Form.Group as={Col} controlId="p1locationrating">
                <Form.Label>Location</Form.Label>
                <Form.Control required type="number" max="10"  placeholder="" value={enteredP1Location} onChange={p1locationChangeHandler}/>
            </Form.Group>

            <Form.Group as={Col} controlId="p1staffrating">
                <Form.Label>Staff</Form.Label>
                <Form.Control required type="number" max="10" placeholder="" value={enteredP1Staff} onChange={p1staffChangeHandler}/>
            </Form.Group>
        </Row>

        <Form.Group className="mb-3" controlId="p1comments">
            <Form.Label>Comments</Form.Label>
        <Form.Control required type="string" placeholder="Enter your comments" value={enteredP1Comments} onChange={p1commentsChangeHandler}/>
        </Form.Group>

        <Form.Text className="AddReview-Form-Text">
          Tom, enter your ratings below:
        </Form.Text> 

        <Row className="AddReview-Form-Tom">
            <Form.Group as={Col} controlId="p2coffeerating">
                <Form.Label>Coffee</Form.Label>
                <Form.Control required type="number" max="10" placeholder="" value={enteredP2Coffee} onChange={p2coffeeChangeHandler}/>
            </Form.Group>

            <Form.Group as={Col} controlId="p2foodrating">
                <Form.Label>Food</Form.Label>
                <Form.Control type="string" placeholder="N/A" value={enteredP2Food} onChange={p2foodChangeHandler}/>
            </Form.Group>

            <Form.Group as={Col} controlId="p2locationrating">
                <Form.Label>Location</Form.Label>
                <Form.Control required type="number" max="10" placeholder="" value={enteredP2Location} onChange={p2locationChangeHandler}/>
            </Form.Group>

            <Form.Group as={Col} controlId="p2staffrating">
                <Form.Label>Staff</Form.Label>
                <Form.Control required type="number" max="10" placeholder="" value={enteredP2Staff} onChange={p2staffChangeHandler}/>
            </Form.Group>
        </Row>
        <Form.Group className="mb-3" controlId="p2comments">
            <Form.Label>Comments</Form.Label>
            <Form.Control required type="string" placeholder="Enter your comments" value={enteredP2Comments} onChange={p2commentsChangeHandler}/>
        </Form.Group>

        <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control required type="password" placeholder="Enter the password" value={enteredPassword} onChange={passwordChangeHandler}/>
        </Form.Group>
      <Button block style={{ backgroundColor: '#B46060', borderColor: "#B46060"}} type="submit">
        Submit
      </Button>
    </Form>
  );
}

export default AddReviewForm;
